<template>
  <header class="sa-dash-header">
    <div class="sa-dash-header__lead">
      <h1 class="sa-dash-header__title">{{ title }}</h1>
      <p class="sa-dash-header__subtitle">{{ subtitle }}</p>
      <p v-if="updatedAt" class="sa-dash-header__meta">Atualizado em {{ updatedAt }}</p>
    </div>
    <div class="sa-dash-header__actions">
      <span v-if="isMock" class="sa-dash-header__mock" role="status">
        <span class="sa-dash-header__mock-dot" aria-hidden="true"></span>
        Dados de demonstração
      </span>
      <router-link to="/admin/relatorios" class="btnSave sa-dash-header__cta">
        Análise e Relatórios
      </router-link>
    </div>
  </header>
</template>

<script>
export default {
  name: 'DashboardHeader',
  props: {
    title: { type: String, default: 'Dashboard' },
    subtitle: { type: String, default: 'Visão executiva das operações Weeduc e Weflix' },
    isMock: { type: Boolean, default: false },
    updatedAt: { type: String, default: '' },
  },
};
</script>

<style scoped>
.sa-dash-header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem 1.5rem;
  padding: 1.5rem 1.75rem 1.25rem;
  background: linear-gradient(180deg, #fafbff 0%, #ffffff 100%);
  border-bottom: 1px solid var(--dashboard-border, #e8eaf0);
}

.sa-dash-header__title {
  margin: 0 0 0.35rem;
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1.2;
  color: var(--dashboard-text, #191c24);
}

.sa-dash-header__subtitle {
  margin: 0;
  font-size: 0.9375rem;
  line-height: 1.45;
  color: var(--dashboard-muted, #697386);
}

.sa-dash-header__meta {
  margin: 0.5rem 0 0;
  font-size: 0.75rem;
  color: var(--dashboard-muted, #697386);
}

.sa-dash-header__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

.sa-dash-header__mock {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.75rem;
  border-radius: 999px;
  background: #fff8eb;
  color: #8a6d1d;
  font-size: 0.75rem;
  font-weight: 600;
  border: 1px solid #f0e0b2;
}

.sa-dash-header__mock-dot {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: #d4a017;
  flex-shrink: 0;
}

.sa-dash-header__cta {
  text-decoration: none;
  display: inline-flex;
  align-items: center;
}

@media (max-width: 768px) {
  .sa-dash-header {
    padding: 1.25rem 1.25rem 1rem;
  }

  .sa-dash-header__title {
    font-size: 1.5rem;
  }

  .sa-dash-header__actions {
    width: 100%;
  }
}
</style>
